export enum ECustomerStatus {
    LEAD = 0,
    ACTIVE = 1,
    BLOCKED = 2,
    INACTIVE = 3,
}

export enum ECustomerActiveStatusType {
    ACTIVE = 1,
    TEMPORARY = 2,
}

export enum ECustomerUserStatus {
    ACTIVE = 1,
    BLOCKED = 2,
    INACTIVE = 3,
}
